module.exports = __webpack_public_path__ + "static/4-e995918e027a1901419557c2b5b13676.png";